<template>
  <div id="show-client-portal-catalogs">
    <v-card class="mt-3">
      <v-card-title>
        {{
          clientPortal.useGroupCatalog ? "Catalogues du groupe" : "Catalogues"
        }}
        <v-spacer></v-spacer>
        <v-btn
          v-if="isGrantedUser()"
          color="primary"
          icon
          @click.stop="createCatalogDialog = true"
          :disabled="clientPortal.useGroupCatalog"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <create-catalog-dialog
          :clientPortal="clientPortal"
          :partner="clientPortal.partner"
          :open.sync="createCatalogDialog"
          v-if="createCatalogDialog && isGrantedUser()"
        ></create-catalog-dialog>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <catalog-datatable
          :is-loading="isLoading"
          :first-load="firstLoad"
          :catalogs="catalogs"
          :partner="clientPortal.partner"
          :disableClick="clientPortal.useGroupCatalog"
        ></catalog-datatable>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import { onMounted, toRefs, watch } from "@vue/composition-api";
import CatalogDatatable from "@/components/Catalog/CatalogDatatable";
import { useCatalogs } from "@/composables/catalog";
import CreateCatalogDialog from "@/components/Catalog/CreateCatalogDialog";
import { useRoles } from "../../composables/roles";

export default {
  props: {
    clientPortal: Object,
    refreshCatalogs: Boolean,
  },
  components: {
    CreateCatalogDialog,
    CatalogDatatable,
  },
  setup(props) {
    /* Import des API */
    const { catalogs, listCatalogs, catalogData } = useCatalogs();
    const { isGrantedUser } = useRoles();

    /* Variables */

    /* Méthodes */
    const fetchCatalog = function () {
      if (!props.clientPortal.useGroupCatalog) {
        listCatalogs(props.clientPortal.id);
      } else {
        listCatalogs(null, props.clientPortal.group.id);
      }
    };

    /* Cycle de vie */
    onMounted(() => {
      fetchCatalog();
    });

    /* Watchers */
    watch(
      () => props.refreshCatalogs,
      (newValue, oldValue) => {
        if (newValue && !oldValue) {
          fetchCatalog();
        }
      }
    );

    return {
      catalogs,
      ...toRefs(catalogData),
      isGrantedUser,
    };
  },
};
</script>
